"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgWifiPaidKzt = function SvgWifiPaidKzt(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wifi-paid-kzt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 9.672c-4.832-4.833-12.668-4.833-17.5 0A1.904 1.904 0 1 1 .558 6.98C6.877.66 17.123.66 23.442 6.98a1.904 1.904 0 1 1-2.692 2.692Zm-8.739 12.082c-1.112 0-1.948-.66-1.948-1.993v-4.636h-3.27c-.825 0-1.221-.517-1.221-1.178 0-.693.396-1.222 1.221-1.222h10.425c.825 0 1.221.529 1.221 1.222 0 .66-.396 1.178-1.221 1.178H13.97v4.636c0 1.332-.825 1.993-1.959 1.993Zm-6.44-11.56c0 .66.397 1.177 1.222 1.177h10.425c.825 0 1.221-.517 1.221-1.177 0-.694-.396-1.222-1.221-1.222H6.793c-.825 0-1.221.528-1.221 1.222Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wifi-paid-kzt_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgWifiPaidKzt);
var _default = exports["default"] = Memo;